export default __webpack_public_path__ + "static/media/JordanWinke.84d71051.jpg";